import GLightbox from 'glightbox';

(() => {
    const blocks = document.querySelectorAll('.section-box');
    blocks.forEach(box => {
        const btn = box.querySelector('.section-box__print');
        if (!btn) return;

        // pokaż przycisk tylko, jeśli data-print jest obecne
        if (box.hasAttribute('data-print')) btn.hidden = false;

        // dostępne aria-label z tytułem
        const title = box.querySelector('.section-box__title')?.textContent?.trim();
        if (title) btn.setAttribute('aria-label', `Drukuj sekcję: ${title}`);

        btn.addEventListener('click', () => {
            box.classList.add('is-printing');
            const cleanup = () => {
                box.classList.remove('is-printing');
                window.removeEventListener('afterprint', cleanup);
            };
            window.addEventListener('afterprint', cleanup, { once: true });
            // krótki tick, żeby CSS się zastosował
            setTimeout(() => window.print(), 10);
        });
    });
})();

/* ===== Submenu: active on view + scroll with offset ===== */
(() => {
    const submenu = document.querySelector('.submenu');
    if (!submenu) return; // ⬅️ najpierw null-check

    // Sticky cień
    const stuckObserver = new IntersectionObserver(
        ([e]) => submenu.classList.toggle('is-stuck', e.intersectionRatio < 1),
        { threshold: [1] }
    );
    stuckObserver.observe(submenu);

    const OFFSET   = 144;
    const scroller = submenu.querySelector('.scrollbar') || submenu.querySelector('.submenu__list'); // ⬅️ kontener do przewijania
    const list     = submenu.querySelector('.submenu__list');
    const items    = Array.from(submenu.querySelectorAll('.submenu__list-item'));
    const links    = Array.from(submenu.querySelectorAll('a[href]'));

    const hashLinks = links.filter(a => a.getAttribute('href').startsWith('#'));
    const sections  = hashLinks
        .map(a => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))))
        .filter(Boolean);

    let ticking = false;
    let isAutoScrolling = false;
    let autoScrollTimer = null;
    let currentActiveId = null;

    const stopAutoScrolling = () => {
        isAutoScrolling = false;
        if (autoScrollTimer) {
            clearTimeout(autoScrollTimer);
            autoScrollTimer = null;
        }
    };
    window.addEventListener('scrollend', stopAutoScrolling);

    // helper: wyrównaj item do początku scroller-a (z uwzględnieniem scroll-padding)
    const alignItemToStart = (container, item, { smooth = true } = {}) => {
        if (!container || !item) return;

        const cs = getComputedStyle(container);
        const dir = cs.direction || 'ltr';
        const padL = parseFloat(cs.scrollPaddingLeft || cs.scrollPadding || 0) || 0;
        const padR = parseFloat(cs.scrollPaddingRight || cs.scrollPadding || 0) || 0;

        // pozycja itemu względem kontenera
        const itemLeft = item.offsetLeft - container.offsetLeft;
        const behavior = smooth ? 'smooth' : 'auto';

        if (dir === 'rtl') {
            // w RTL scrollLeft bywa ujemny — bezpieczniej liczyć od prawej krawędzi
            const rightEdge = container.scrollWidth - (itemLeft + item.offsetWidth);
            const target = Math.max(0, rightEdge - padR);
            container.scrollTo({ left: target, behavior });
        } else {
            const target = Math.max(0, itemLeft - padL);
            container.scrollTo({ left: target, behavior });
        }
    };

    const setActive = (id, { fromClick = false } = {}) => {
        if (!id || id === currentActiveId) return;

        currentActiveId = id;

        items.forEach(li => li.classList.remove('active'));
        links.forEach(a => a.removeAttribute('aria-current'));

        const a = hashLinks.find(link => decodeURIComponent(link.getAttribute('href')).replace('#','') === id);
        if (!a) return;

        a.setAttribute('aria-current', 'true');
        const li = a.closest('.submenu__list-item');
        if (li) {
            li.classList.add('active');

            // ZAWSZE wyrównuj aktywny element do początku scroller-a
            // – zarówno po kliknięciu, jak i przy scroll-spy.
            alignItemToStart(scroller, li, { smooth: true });
        }
    };

    const scrollToSection = (id, { updateHash = true } = {}) => {
        const target = document.getElementById(id);
        if (!target) return;

        const y = window.scrollY + target.getBoundingClientRect().top - OFFSET;

        isAutoScrolling = true;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });

        // fallback gdy 'scrollend' nie zadziała
        autoScrollTimer = setTimeout(stopAutoScrolling, 800);

        if (updateHash) history.pushState(null, '', `#${encodeURIComponent(id)}`);
    };

    // Klik w pozycję
    hashLinks.forEach(a => {
        a.addEventListener('click', (e) => {
            e.preventDefault();
            const id = decodeURIComponent(a.getAttribute('href').slice(1));
            scrollToSection(id, { updateHash: true });
            setActive(id, { fromClick: true });
        });
    });

    const isInViewWithOffset = (section) => {
        const r = section.getBoundingClientRect();
        const y = OFFSET;
        return r.top <= y && r.bottom > y;
    };

    const updateOnScroll = () => {
        if (ticking || isAutoScrolling) return;
        ticking = true;
        requestAnimationFrame(() => {
            ticking = false;
            const current = sections.find(isInViewWithOffset);
            if (current) setActive(current.id);
        });
    };

    window.addEventListener('scroll', updateOnScroll, { passive: true });
    window.addEventListener('resize', updateOnScroll);

    // wstecz/dalej
    window.addEventListener('hashchange', () => {
        const id = decodeURIComponent(location.hash.slice(1));
        if (!id) return;
        scrollToSection(id, { updateHash: false });
        setActive(id);
    });

    // Start
    const init = () => {
        if (location.hash) {
            const id = decodeURIComponent(location.hash.slice(1));
            const target = document.getElementById(id);
            if (target) {
                const y = window.scrollY + target.getBoundingClientRect().top - OFFSET;
                window.scrollTo(0, Math.max(0, y));
                setActive(id, { fromClick: false });
                return;
            }
        }
        updateOnScroll();
    };

    init();
})();

// gallery + lightbox (fix drag-freeze on resize/close + Esc/backdrop close)
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.hero__image');
    if (!root) return;

    const TRANSITION_MS = 350; // musi być >= CSS transition
    let animFallback = null;

    const mainHolder = root.querySelector('.hero__image-main .holder');
    const thumbsWrap = root.querySelector('.hero__image-thumbs');
    const thumbsUl   = thumbsWrap?.querySelector('.thumbs');
    const items      = Array.from(thumbsUl?.querySelectorAll('.thumbs__item') || []);

    const btnPrev = root.querySelector('.hero__image-main .icon-left');
    const btnNext = root.querySelector('.hero__image-main .icon-right');
    const btnZoom = root.querySelector('.hero__image-main .icon-zoom');

    // disable native img drag
    root.querySelectorAll('img').forEach(i => i.setAttribute('draggable','false'));
    root.addEventListener('dragstart', e => e.preventDefault());

    // sources from thumbs (fallback: img in holder)
    const getData = li => {
        const img = li.querySelector('img');
        return {
            src: img?.dataset.slideSrc || img?.getAttribute('src') || '', // do slidera (zestawy: większy plik niż miniatura)
            large: img?.dataset.largeImage || img?.getAttribute('src'), // do zoomu
            alt: img?.getAttribute('alt') || ''
        };
    };

    let sources = items.map(getData);
    const fallbackImg = mainHolder.querySelector('img');
    if (!sources.length && fallbackImg) sources = [{ src: fallbackImg.src, alt: fallbackImg.alt || '' }];

    // move padding from holder into slides (avoid offset)
    const cs  = getComputedStyle(mainHolder);
    const pad = {
        t: +parseFloat(cs.paddingTop)    || 0,
        r: +parseFloat(cs.paddingRight)  || 0,
        b: +parseFloat(cs.paddingBottom) || 0,
        l: +parseFloat(cs.paddingLeft)   || 0,
    };
    mainHolder.style.padding = '0';

    let startActive = Math.max(0, items.findIndex(li => li.classList.contains('active')));
    if (startActive < 0) startActive = 0;

    // build track: [cloneLast, ...slides, cloneFirst]
    // SLICD-34: aktywny slajd przejmuje <img> wyrenderowany przez serwer (ten sam plik) zamiast tworzyć
    // nowy - zdjęcie jest LCP strony i jest już narysowane, więc nie czeka na ten skrypt.
    const track = document.createElement('div'); track.className='track';
    const makeSlide = ({src,alt}, existingImg = null) => {
        const s = document.createElement('div'); s.className='slide';
        s.style.padding = `${pad.t}px ${pad.r}px ${pad.b}px ${pad.l}px`;
        if (existingImg) {
            s.appendChild(existingImg);
        } else {
            // Pozostałe slajdy są poza ekranem (translateX) - ładują się dopiero przy przewijaniu galerii.
            const i = document.createElement('img'); i.loading='lazy'; i.decoding='async'; i.src=src; i.alt=alt||''; s.appendChild(i);
        }
        return s;
    };
    const reuseImg = fallbackImg && sources[startActive] && fallbackImg.getAttribute('src') === sources[startActive].src ? fallbackImg : null;
    track.appendChild(makeSlide(sources[sources.length-1]));
    sources.forEach((d, i) => track.appendChild(makeSlide(d, i === startActive ? reuseImg : null)));
    track.appendChild(makeSlide(sources[0]));
    mainHolder.innerHTML=''; mainHolder.appendChild(track);

    // state
    const count = sources.length, mod = (n,m)=>((n%m)+m)%m;
    const isSingleImage = count <= 1;
    // === HIDE ARROWS WHEN ONLY ONE IMAGE ===
    if (isSingleImage) {
        btnPrev?.classList.add('is-hidden');
        btnNext?.classList.add('is-hidden');
    }

    let index= startActive + 1, slideW=0;
    let animating = false;
    let queuedIndex = null;
    let queuedDir   = null; // 'next' | 'prev'

    const setNavDisabled = (on) => {
        btnPrev?.classList.toggle('is-disabled', on);
        btnNext?.classList.toggle('is-disabled', on);
    };

    function jumpTo(i){
        index = i;
        const prev = track.style.transition;
        track.style.transition='none';
        track.style.transform = `translateX(${-(index*slideW)}px)`;
        track.getBoundingClientRect(); // reflow
        track.style.transition= prev || 'transform .3s ease';
    }
    function goTo(i){ index=i; track.style.transform=`translateX(${-(index*slideW)}px)`; }

    // === FIX: safe resize (avoid stuck anim state) ===
    function setSizes(){
        const prev = track.style.transition;
        track.style.transition='none';
        slideW = mainHolder.clientWidth;
        [...track.children].forEach(el => el.style.width = slideW + 'px');
        track.style.transform = `translateX(${-(index*slideW)}px)`;
        track.getBoundingClientRect();
        track.style.transition = prev || 'transform .3s ease';

        if (animating){
            animating = false;
            queuedIndex = null;
            queuedDir   = null;
            setNavDisabled(false);
        }
        sync();
    }

    // guarded navigation (queue when animating)
    function startAnimation() {
        animating = true;
        setNavDisabled(true);

        clearTimeout(animFallback);
        animFallback = setTimeout(() => {
            // fallback gdy transitionend nie strzeli
            animating = false;
            setNavDisabled(false);
            sync();
        }, TRANSITION_MS);
    }

    function safeNext(){
        if (animating){ queuedIndex = null; queuedDir = 'next'; return; }
        startAnimation();
        goTo(index + 1);
    }

    function safePrev(){
        if (animating){ queuedIndex = null; queuedDir = 'prev'; return; }
        startAnimation();
        goTo(index - 1);
    }

    function safeGoTo(i){
        if (animating){ queuedIndex = i; queuedDir = null; return; }
        startAnimation();
        goTo(i);
    }

    // thumbs active + autoscroll
    function setActive(iReal){
        thumbsUl?.querySelector('.thumbs__item.active')?.classList.remove('active');
        items[iReal]?.classList.add('active');
        updateProductNameFromActiveThumb();
    }

    function updateProductNameFromActiveThumb() {
        const activeThumb = document.querySelector('.thumbs__item.active');
        if (!activeThumb) return;

        const productTitle = activeThumb.dataset.productTitle;
        if (!productTitle) return;

        const productNameEl = document.querySelector('.hero__image .productName');
        if (!productNameEl) return;

        productNameEl.textContent = productTitle;
    }

    function scrollThumbTo(i){
        if (!thumbsWrap || !items[i]) return;
        const c = thumbsWrap, li = items[i];
        const liRect = li.getBoundingClientRect(), cRect = c.getBoundingClientRect();
        const leftInContent = liRect.left - cRect.left + c.scrollLeft;
        const target = Math.min(Math.max(0, leftInContent + liRect.width/2 - c.clientWidth/2), c.scrollWidth - c.clientWidth);
        c.scrollTo({ left: target, behavior: 'smooth' });
    }
    function sync(){
        const real = mod(index-1, count);
        setActive(real);
        scrollThumbTo(real);
    }

    setSizes();
    let rz;
    window.addEventListener('resize', () => {
        cancelAnimationFrame(rz);
        rz = requestAnimationFrame(setSizes);
    });

    // loop + queue drain
    track.addEventListener('transitionend', (ev) => {
        if (ev.propertyName !== 'transform') return;

        clearTimeout(animFallback); // ⬅️ KLUCZOWE

        if (index === 0)            jumpTo(count);
        else if (index === count+1) jumpTo(1);

        sync();

        animating = false;
        setNavDisabled(false);

        if (queuedIndex != null){
            const qi = queuedIndex; queuedIndex = null;
            safeGoTo(qi);
        } else if (queuedDir){
            const dir = queuedDir; queuedDir = null;
            dir === 'next' ? safeNext() : safePrev();
        }
    });

    // arrows
    [btnPrev, btnNext].forEach(btn => btn?.addEventListener('pointerdown', e=>e.stopPropagation(), {passive:true}));
    btnPrev?.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); safePrev(); });
    btnNext?.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); safeNext(); });

    // main drag/swipe
    let sx=0, sy=0, dx=0, draggingMain=false; const TH=40;

    mainHolder.addEventListener('pointerdown', e=>{
        if (e.button !== 0 || animating) return;
        draggingMain=true; sx=e.clientX; sy=e.clientY; dx=0;
        track.classList.add('is-dragging'); track.style.transition='none';
        mainHolder.setPointerCapture?.(e.pointerId);
    }, {passive:true});

    mainHolder.addEventListener('pointermove', e=>{
        if(!draggingMain) return;
        const mx=e.clientX-sx, my=e.clientY-sy;
        if (Math.abs(mx)>Math.abs(my)) e.preventDefault();
        dx=mx; track.style.transform=`translateX(${-(index*slideW)+dx}px)`;
    }, {passive:false});

    function endMain(e){
        if(!draggingMain) return;
        draggingMain=false;
        track.classList.remove('is-dragging'); track.style.transition='transform .3s ease';
        if (Math.abs(dx)>TH) (dx<0 ? safeNext() : safePrev()); else safeGoTo(index);
        dx=0; mainHolder.releasePointerCapture?.(e.pointerId);
    }
    mainHolder.addEventListener('pointerup', endMain);
    mainHolder.addEventListener('pointercancel', endMain);
    mainHolder.addEventListener('pointerleave', endMain);

    // keyboard
    mainHolder.tabIndex = 0;
    mainHolder.addEventListener('keydown', e=>{
        if (e.key==='ArrowLeft')  { e.preventDefault(); safePrev(); }
        if (e.key==='ArrowRight') { e.preventDefault(); safeNext(); }
    });

    // === SIMPLE THUMB CLICK (NO DRAG) ===
    items.forEach((li, i) => {
        li.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (animating) return;

            safeGoTo(i + 1);
            setActive(i);
            scrollThumbTo(i);
        });
    });

    // =========================
    // LIGHTBOX
    // =========================
    const lightboxItems = sources.map(img => ({
        href: img.large,
        type: 'image',
        title: img.alt || ''
    }));
    const lightbox = GLightbox({
        elements: lightboxItems,

        // nawigacja
        loop: !isSingleImage,
        arrows: !isSingleImage,
        touchNavigation: true,
        keyboardNavigation: true,

        // 🔍 ZOOM
        zoomable: true,        // ⬅️ WŁĄCZA ZOOM
        draggable: true,       // przeciąganie powiększonego obrazu
        openEffect: 'zoom',    // ładna animacja
        closeEffect: 'zoom',

        closeButton: true
    });

    btnZoom?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // aktualny slajd slidera
        const activeIndex = mod(index - 1, count);

        lightbox.openAt(activeIndex);
    });
});

// dealers-modal.js
(() => {
    const modal = document.getElementById('dealers-modal');
    if (!modal) return;

    const dialog = modal.querySelector('.dealers__dialog');
    const closeBtn = modal.querySelector('.dealers__close');
    const triggers = document.querySelectorAll('.js-open-dealers');
    const countEl = modal.querySelector('.dealers__count');
    const input   = modal.querySelector('#dealers-city');

    // Zarządzanie modalem
    let lastFocus = null;
    const getFocusables = () =>
        Array.from(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
            .filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));

    const open = () => {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('is-locked');
        input.value = '';
        const f = getFocusables(); (f[0] || dialog).focus({preventScroll:true});
    };

    const close = () => {
        modal.hidden = true;
        document.body.classList.remove('is-locked');
        if (lastFocus) lastFocus.focus({preventScroll:true});
    };

    // Otwieranie po kliknięciu w "Sprawdź gdzie kupić"
    triggers.forEach(el => {
        el.setAttribute('role', 'button');
        el.setAttribute('aria-haspopup', 'dialog');
        el.addEventListener('click', (e) => {
            e.preventDefault();
            open();
        });
    });

    // Zamknięcie po kliknięciu w tło
    modal.addEventListener('click', (e) => {
        if (e.target === modal) close();
    });

    // Zamknięcie po kliknięciu w X
    closeBtn.addEventListener('click', close);

    // ESC i focus trap
    document.addEventListener('keydown', (e) => {
        if (modal.hidden) return;
        if (e.key === 'Escape') close();

        if (e.key === 'Tab') {
            const f = getFocusables();
            if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
            else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
        }
    });

    // Wyszukiwanie punktów sklepowych
    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector(".dealers__search");
        const input = document.querySelector("#dealers-city");
        const companiesCol = document.querySelector(".dealers__list");
        let timeout = null;

        // ✅ Tworzymy dropdown globalnie (w <body>, nie w modalu)
        const results = document.createElement("div");
        results.className = "autocomplete-results";
        results.style.display = "none";
        document.body.appendChild(results);

        // ---------------------------------
        // Funkcja pobierająca dane firm
        // ---------------------------------
        function getDataCompanies(form, localizationId, localizationName) {
            if (!form) return;

            const button = form.querySelector("button");
            const copyButtonIcon = button.querySelector("svg")?.cloneNode(true);
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

            const loadingIcon = `
            <svg fill="#097aff" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100" xml:space="preserve">
                <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50
                        M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform attributeName="transform" attributeType="XML"
                        type="rotate" dur="1s" from="0 50 50"
                        to="360 50 50" repeatCount="indefinite" />
                </path>
            </svg>
        `;

            button.innerHTML = loadingIcon;

            fetch(form.action, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest",
                    ...(csrfToken && { "X-CSRF-Token": csrfToken }),
                },
                body: new URLSearchParams({
                    localizationName: localizationName ?? "",
                    localizationId: localizationId ?? "",
                }),
            })
                .then((r) => r.json())
                .then((response) => {
                    if (response.code === 200) {
                        const { view } = response;
                        if (companiesCol) {
                            companiesCol.innerHTML = view;
                            companiesCol.style.display = "block";
                        }
                    } else {
                        throw new Error(response.message || "Nieznany błąd");
                    }
                })
                .catch((err) => {
                    console.error("Błąd w getDataCompanies:", err);
                    alert("Wystąpił błąd. Spróbuj ponownie później.");
                })
                .finally(() => {
                    button.innerHTML = "";
                    if (copyButtonIcon) button.appendChild(copyButtonIcon);
                });
        }

        // ---------------------------------
        // Obsługa submit formularza
        // ---------------------------------
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            const localizationName = form.querySelector('input[name="localization"]').value;
            getDataCompanies(form, null, localizationName);
        });

        // ---------------------------------
        // Pozycjonowanie dropdowna (dynamicznie)
        // ---------------------------------
        function positionResults() {
            const rect = input.getBoundingClientRect();
            const dropdownHeight = results.offsetHeight || 200;
            const viewportHeight = window.innerHeight;

            let top = rect.bottom + window.scrollY;
            if (rect.bottom + dropdownHeight > viewportHeight) {
                top = rect.top + window.scrollY - dropdownHeight;
            }

            results.style.position = "absolute";
            results.style.top = `${top}px`;
            results.style.left = `${rect.left + window.scrollX}px`;
            results.style.width = `${rect.width}px`;
            results.style.zIndex = "99999";
        }

        // ---------------------------------
        // Podpowiedzi miejscowości (autocomplete)
        // ---------------------------------
        input.addEventListener("input", function () {
            const query = this.value.trim();
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                if (query.length < 2) {
                    results.style.display = "none";
                    results.innerHTML = "";
                    return;
                }

                fetch(`/ajax/localization-autocomplete?query=${encodeURIComponent(query)}`)
                    .then((response) => response.json())
                    .then((data) => {
                        results.innerHTML = "";

                        // ✅ Jeśli backend zwrócił obiekt, konwertujemy go na tablicę
                        const items = Array.isArray(data) ? data : Object.values(data);

                        if (!items.length) {
                            const emptyDiv = document.createElement("div");
                            emptyDiv.classList.add("autocomplete-item", "disabled");
                            emptyDiv.textContent = "Brak wyników";
                            results.appendChild(emptyDiv);
                            positionResults();
                            results.style.display = "block";
                            return;
                        }

                        // ✅ Tworzymy elementy wyników
                        items.forEach((item) => {
                            const div = document.createElement("div");
                            div.classList.add("autocomplete-item");
                            div.dataset.localizationId = item.id;
                            div.dataset.localizationName = item.name;
                            div.textContent = `${item.name} (${item.api_voivodeship_name})`;
                            results.appendChild(div);
                        });

                        positionResults();
                        results.style.display = "block";
                    })
                    .catch(() => {
                        results.innerHTML = '<div class="autocomplete-item disabled">Błąd pobierania danych</div>';
                        positionResults();
                        results.style.display = "block";
                    });
            }, 200);
        });

        // ---------------------------------
        // Kliknięcie w element listy (delegacja)
        // ---------------------------------
        document.addEventListener("click", (e) => {
            const target = e.target.closest(".autocomplete-item");
            if (!target) {
                results.style.display = "none";
                return;
            }
            if (target.classList.contains("disabled")) return;

            e.preventDefault();

            const localizationId = target.dataset.localizationId;
            const localizationName = target.dataset.localizationName;

            input.value = localizationName;
            results.style.display = "none";

            getDataCompanies(form, localizationId, localizationName);
        });

        // ---------------------------------
        // Ukrywanie dropdowna przy kliknięciu poza input
        // ---------------------------------
        document.addEventListener("click", (e) => {
            if (!e.target.closest("#dealers-city") && !e.target.closest(".autocomplete-results")) {
                results.style.display = "none";
            }
        });

        window.addEventListener("scroll", () => {
            if (results.style.display === "block") positionResults();
        });
        window.addEventListener("resize", () => {
            if (results.style.display === "block") positionResults();
        });
    });


})();

(() => {
    const onReady = (fn) =>
        document.readyState === 'loading'
            ? document.addEventListener('DOMContentLoaded', fn, { once: true })
            : fn();

    onReady(() => {
        // 1) Znajdź formularz "zapytaj o cenę"
        const form =
            document.querySelector('.question-form') ||
            document.querySelector('form[action*="ask-for-price"]');
        if (!form) return;

        form.setAttribute('novalidate', '');

        // 2) Pobierz pola
        const fields = {
            product: form.querySelector('#product'),
            company: form.querySelector('#company'),
            nip: form.querySelector('#nip'),
            street: form.querySelector('#street'),
            number: form.querySelector('#number'),
            city: form.querySelector('#city'),
            zip: form.querySelector('#zip'),
            contactPerson: form.querySelector('#contact-person'),
            phone: form.querySelector('#phone'),
            email: form.querySelector('#email'),
            quantity: form.querySelector('#quantity'),
        };

        // 3) Pomocnicze funkcje błędów
        const hostOf = (input) => input.closest('.form__group') || input.parentElement || input;
        const setError = (input, msg) => {
            if (!input) return false;
            input.setAttribute('aria-invalid', 'true');
            const host = hostOf(input);
            let err = host.querySelector('.form__error');
            if (!err) {
                err = document.createElement('div');
                err.className = 'form__error';
                err.setAttribute('role', 'alert');
                host.appendChild(err);
            }
            err.textContent = msg;
            return false;
        };
        const clearError = (input) => {
            if (!input) return;
            input.setAttribute('aria-invalid', 'false');
            const err = hostOf(input).querySelector('.form__error');
            if (err) err.remove();
        };

        // 4) Formatery
        const fmtPostal = (v) => {
            const d = String(v || '').replace(/\D+/g, '').slice(0, 5);
            return d.length <= 2 ? d : `${d.slice(0, 2)}-${d.slice(2)}`;
        };
        const fmtPLPhone = (v) => {
            const digits = String(v || '').replace(/\D+/g, '');
            let rest = digits.startsWith('48') ? digits.slice(2) : digits;
            rest = rest.slice(0, 9);
            const parts = [rest.slice(0, 3), rest.slice(3, 6), rest.slice(6, 9)].filter(Boolean);
            return rest ? `+48 ${parts.join(' ')}`.trim() : '';
        };
        const keepCaret = (el, oldVal, newVal) => {
            const pos = el.selectionStart ?? newVal.length;
            const diff = newVal.length - oldVal.length;
            const next = Math.max(0, pos + diff);
            el.value = newVal;
            try { el.setSelectionRange(next, next); } catch {}
        };

        // 5) Walidacje
        const emailBasic = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
        const nipValid = (v) => {
            const cleaned = v.replace(/[^0-9]/g, ''); // usuwa wszystko oprócz cyfr
            return /^\d{10}$/.test(cleaned);
        };

        const validators = {
            company: () => {
                const el = fields.company;
                const v = el.value.trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            nip: () => {
                const el = fields.nip;
                const v = el.value.trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!nipValid(v)) return setError(el, el.dataset.format);
                clearError(el); return true;
            },
            street: () => {
                const el = fields.street;
                const v = el.value.trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            number: () => {
                const el = fields.number;
                const v = el.value.trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            city: () => {
                const el = fields.city;
                const v = el.value.trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            zip: () => {
                const el = fields.zip;
                const v = el.value.trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!/^\d{2}-\d{3}$/.test(v)) return setError(el, el.dataset.format);
                clearError(el); return true;
            },
            contactPerson: () => {
                const el = fields.contactPerson;
                const v = el.value.trim();
                return v ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
            phone: () => {
                const el = fields.phone;
                const v = el.value.trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!/^\+48 \d{3} \d{3} \d{3}$/.test(v)) return setError(el, el.dataset.format);
                clearError(el); return true;
            },
            email: () => {
                const el = fields.email;
                const v = el.value.trim();
                if (!v) return setError(el, el.dataset.msg);
                if (!v.includes('@')) return setError(el, el.dataset.monkey);
                if (!emailBasic(v)) return setError(el, el.dataset.trueEmail || el.dataset.true_email);
                clearError(el); return true;
            },
            quantity: () => {
                const el = fields.quantity;
                const v = parseInt(el.value, 10);
                return v > 0 ? (clearError(el), true) : setError(el, el.dataset.msg);
            },
        };

        // 6) Formatowanie i walidacja live
        fields.zip?.addEventListener('input', (e) => {
            const old = e.target.value;
            const next = fmtPostal(old);
            keepCaret(e.target, old, next);
            clearError(e.target);
        });
        fields.zip?.addEventListener('blur', () => {
            fields.zip.value = fmtPostal(fields.zip.value);
            validators.zip();
        });

        fields.phone?.addEventListener('input', (e) => {
            const old = e.target.value;
            const next = fmtPLPhone(old);
            keepCaret(e.target, old, next);
            clearError(e.target);
        });
        fields.phone?.addEventListener('blur', () => {
            fields.phone.value = fmtPLPhone(fields.phone.value);
            validators.phone();
        });

        Object.keys(fields).forEach((key) => {
            const el = fields[key];
            if (!el) return;
            el.addEventListener('input', () => clearError(el));
            el.addEventListener('blur', validators[key]);
        });

        // 7) Funkcje UI
        const submitButton = form.querySelector('[type="submit"]');
        const messageEl = form.querySelector('.form__message');
        const showMessage = (msg, type = 'success') => {
            messageEl.textContent = msg;
            messageEl.className = 'form__message ' + type;
            messageEl.style.display = 'inline-block';
            setTimeout(() => messageEl.classList.add('visible'), 10);
            setTimeout(() => {
                messageEl.classList.remove('visible');
                setTimeout(() => messageEl.style.display = 'none', 400);
            }, 7000);
        };

        const disableSubmitButton = () => {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.6';
            submitButton.setAttribute('aria-disabled', 'true');
            if (!submitButton.querySelector('.loader')) {
                const loader = document.createElement('span');
                loader.classList.add('loader');
                loader.style.marginLeft = '8px';
                submitButton.appendChild(loader);
            }
        };

        const enableSubmitButton = () => {
            submitButton.disabled = false;
            submitButton.style.opacity = '1';
            submitButton.removeAttribute('aria-disabled');
            submitButton.querySelector('.loader')?.remove();
        };

        const resetInputs = () => {
            form.querySelectorAll('input:not([type=hidden]), textarea').forEach(el => el.value = '');
        };

        const resetGrecaptcha = () => {
            const field = form.querySelector("[name='g-recaptcha-response']");
            if (!field) return;
            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaSiteKey, { action: form.getAttribute('action') })
                    .then((token) => field.value = token)
                    .catch(console.error);
            });
        };

        // 8) Submit z AJAX
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const ok = Object.keys(validators).every((k) => validators[k]());

            if (!ok) {
                const first = form.querySelector('[aria-invalid="true"]');
                if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }

            disableSubmitButton();

            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaSiteKey, { action: form.getAttribute('action') })
                    .then((token) => {
                        form.querySelector("[name='g-recaptcha-response']").value = token;
                        sendForm();
                    })
                    .catch((err) => {
                        showMessage(form.dataset.recaptcha_error, 'error');
                        console.error(err);
                        enableSubmitButton();
                    });
            });
        });

        function sendForm() {
            const url = form.getAttribute('action');
            const formData = new FormData(form);

            fetch(url, {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.code === 200) {
                        showMessage(data.message);
                        resetInputs();
                        resetGrecaptcha();
                    } else if (data.errors) {
                        showMessage(form.dataset.form_error, 'error');
                        form.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
                        form.querySelectorAll('.form__error').forEach(el => el.remove());

                        Object.entries(data.errors).forEach(([name, msgs]) => {
                            const field = form.querySelector(`[name="${name}"]`);
                            if (field) setError(field, msgs[0]);
                        });
                    } else {
                        showMessage(data.message || form.dataset.sending_error, 'error');
                    }
                })
                .catch(() => showMessage(form.dataset.network_error, 'error'))
                .finally(enableSubmitButton);
        }
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    const questionModal = document.querySelector('#question-modal');
    const openButtons = document.querySelectorAll('.modalQuestionButton');
    const closeButton = questionModal.querySelector('.doc-modal__close');

    // otwieranie modala
    openButtons.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            questionModal.removeAttribute('hidden');
            document.body.style.overflow = 'hidden'; // blokuje scroll
        });
    });

    // zamykanie po kliknięciu w przycisk
    closeButton.addEventListener('click', () => {
        questionModal.setAttribute('hidden', '');
        document.body.style.overflow = '';
    });

    // zamykanie po kliknięciu w tło
    questionModal.addEventListener('click', e => {
        if (e.target === questionModal) {
            questionModal.setAttribute('hidden', '');
            document.body.style.overflow = '';
        }
    });

    // zamykanie po ESC
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !questionModal.hasAttribute('hidden')) {
            questionModal.setAttribute('hidden', '');
            document.body.style.overflow = '';
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('.catalog__grid-carousel');
    if (!carousel) return;

    const allItems = Array.from(carousel.querySelectorAll('.product-card[data-product]'));
    if (allItems.length <= 1) return; // za mało na karuzelę

    let visibleCount = getVisibleCount();
    let currentIndex = 0;

    function getVisibleCount() {
        const w = window.innerWidth;
        if (w <= 540) return 1;
        if (w <= 768) return 2;
        if (w <= 1920) return 3;
        return 4;
    }

    function clampIndex(index) {
        const len = allItems.length;
        return ((index % len) + len) % len;
    }

    function renderView() {
        carousel.innerHTML = '';
        const count = Math.min(visibleCount, allItems.length);

        for (let i = 0; i < count; i++) {
            const itemIndex = clampIndex(currentIndex + i);
            const item = allItems[itemIndex];
            carousel.appendChild(item);
        }
    }

    // początkowy widok
    renderView();

    // Nawigacja (strzałki)
    const controlsWrapper = document.createElement('div');
    controlsWrapper.className = 'catalog-carousel__controls';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'catalog-carousel__control catalog-carousel__control--prev';
    prevBtn.setAttribute('aria-label', 'Pokaż poprzednie produkty');
    prevBtn.innerHTML = `
<svg viewBox='0 0 10 17' xmlns='http://www.w3.org/2000/svg' width='18' height='32' aria-hidden='true'>
    <path d='M9.32 1.2L2.33 8.1l6.99 6.9' fill='none' stroke='#000' stroke-width='2'/>
</svg>
`;

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'catalog-carousel__control catalog-carousel__control--next';
    nextBtn.setAttribute('aria-label', 'Pokaż kolejne produkty');
    nextBtn.innerHTML = `
<svg viewBox='0 0 10 17' xmlns='http://www.w3.org/2000/svg' width='18' height='32' aria-hidden='true'>
    <path d='M0.68 1.2L7.67 8.1l-6.99 6.9' fill='none' stroke='#000' stroke-width='2'/>
</svg>
`;

    controlsWrapper.appendChild(prevBtn);
    controlsWrapper.appendChild(nextBtn);

    const section = carousel.closest('section.catalog__grid-carousel') || carousel;
    section.parentNode.insertBefore(controlsWrapper, section.nextSibling);

    function showNext() {
        currentIndex = clampIndex(currentIndex + 1);
        renderView();
    }

    function showPrev() {
        currentIndex = clampIndex(currentIndex - 1);
        renderView();
    }

    nextBtn.addEventListener('click', showNext);
    prevBtn.addEventListener('click', showPrev);

    // Responsywność – na resize zmieniamy liczbę widocznych kart
    let resizeTimeout = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newCount = getVisibleCount();
            if (newCount !== visibleCount) {
                visibleCount = newCount;
                renderView();
            }
        }, 150);
    });

});

// reguły

(function () {
    const carouselState = new WeakMap(); // { index, total }
    const dragState = new WeakMap();     // { isDown, startX }

    document.querySelectorAll('[data-rules]').forEach(initRulesModule);

    function initRulesModule(moduleEl) {
        const tabs  = moduleEl.querySelectorAll('[data-rules-tab]');
        const items = moduleEl.querySelectorAll('[data-rules-item]');

        // --- TABS ---
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const category = tab.dataset.category;

                tabs.forEach(t => {
                    const isActive = t === tab;
                    t.classList.toggle('rules__tab--active', isActive);
                    t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });

                items.forEach(item => {
                    const match = !category || item.dataset.category === category;
                    item.style.display = match ? '' : 'none';
                });
            });
        });

        const activeTab = moduleEl.querySelector('.rules__tab--active[data-rules-tab]');
        if (activeTab) activeTab.click();

        // --- TOGGLE PANELI + KARUZELE ---
        moduleEl.querySelectorAll('[data-rules-toggle]').forEach(btn => {
            // ===========================
            // 👉 INICJALIZACJA TEKSTU
            // ===========================
            const expandTitle = btn.dataset.expandTitle || 'Rozwiń';
            const labelEl = btn.querySelector('.toggle-class');
            if (labelEl) {
                labelEl.textContent = expandTitle;   // ← ustawiamy "Rozwiń" przy starcie
            }

            // ===========================
            // 👉 TOGGLE
            // ===========================
            btn.addEventListener('click', () => {
                const productEl = btn.closest('[data-rules-item]');
                const panel = productEl.querySelector('[data-rules-panel]');
                const isOpen = !panel.hidden;

                panel.hidden = isOpen;
                btn.setAttribute('aria-expanded', String(!isOpen));
                btn.classList.toggle('expanded', !isOpen);

                // dynamiczne tytuły
                const collapseTitle = btn.dataset.collapseTitle || 'Zwiń';
                const expandTitle = btn.dataset.expandTitle || 'Rozwiń';
                const newText = isOpen ? expandTitle : collapseTitle;

                if (labelEl) {
                    labelEl.textContent = newText;
                }

                // lazy init karuzeli
                if (!isOpen) {
                    const carouselEl = panel.querySelector('[data-rules-carousel]');
                    if (carouselEl && !carouselEl.dataset.initialized) {
                        initCarousel(carouselEl);
                    }
                }
            });
        });



    }

    /* =========================
       KARUZELA
    ========================= */

    function getSlidesPerView() {
        const w = window.innerWidth;

        if (w <= 560) return 1;
        if (w <= 768) return 2;
        return 3;
    }

    function initCarousel(carouselEl) {
        const track    = carouselEl.querySelector('[data-rules-track]');
        const slides   = carouselEl.querySelectorAll('[data-rules-slide]');
        const dotsWrap = carouselEl.querySelector('[data-rules-dots]');
        if (!track || !slides.length || !dotsWrap) return;

        const perView = getSlidesPerView();
        carouselEl.dataset.slidesPerView = perView;

        const state = {
            index: 0,                            // ✅ indeks slajdu (start)
            max: Math.max(0, slides.length - perView) // ✅ max przesunięcie o 1 slajd
        };

        carouselState.set(carouselEl, state);

        buildDots(carouselEl);
        carouselEl.dataset.initialized = 'true';
        updateCarouselTransform(carouselEl);
        initSwipe(carouselEl);

        window.addEventListener('resize', () => rebuildDots(carouselEl));
    }

    function buildDots(carouselEl) {
        const dotsWrap = carouselEl.querySelector('[data-rules-dots]');
        const state = carouselState.get(carouselEl);
        if (!dotsWrap || !state) return;

        dotsWrap.innerHTML = '';

        const totalDots = state.max + 1;
        for (let i = 0; i < totalDots; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'rules-carousel__dot';
            dot.dataset.index = i;

            dot.classList.toggle('rules-carousel__dot--active', i === state.index);
            dot.addEventListener('click', () => goToSlide(carouselEl, i));

            dotsWrap.appendChild(dot);
        }
    }

    function rebuildDots(carouselEl) {
        const slides = carouselEl.querySelectorAll('[data-rules-slide]');
        if (!slides.length) return;

        const perView = getSlidesPerView();
        const state = carouselState.get(carouselEl);
        if (!state) return;

        carouselEl.dataset.slidesPerView = perView;
        state.max = Math.max(0, slides.length - perView);
        state.index = Math.max(0, Math.min(state.index, state.max));

        buildDots(carouselEl);
        updateCarouselTransform(carouselEl);
    }

    function updateCarouselTransform(carouselEl) {
        const state    = carouselState.get(carouselEl);
        const viewport = carouselEl.querySelector('.rules-carousel__viewport');
        const track    = carouselEl.querySelector('[data-rules-track]');
        if (!state || !viewport || !track) return;

        const step = getStepPx(carouselEl);

        // ile max można przesunąć w lewo, żeby nie pojawiła się pusta prawa strona
        const viewportW = viewport.getBoundingClientRect().width;
        const trackW    = track.scrollWidth; // uwzględnia gapy
        const maxOffset = Math.max(0, trackW - viewportW);

        // docelowy offset z indeksu
        let offset = state.index * step;

        // ✅ twardy limit końca
        offset = Math.min(Math.max(0, offset), maxOffset);

        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    }

    function goToSlide(carouselEl, index) {
        const state = carouselState.get(carouselEl);
        if (!state) return;

        state.index = Math.max(0, Math.min(index, state.max));

        const dots = carouselEl.querySelectorAll('.rules-carousel__dot');
        dots.forEach((dot, i) => dot.classList.toggle('rules-carousel__dot--active', i === state.index));

        updateCarouselTransform(carouselEl);
    }

    function getStepPx(carouselEl) {
        const track = carouselEl.querySelector('[data-rules-track]');
        const slide = carouselEl.querySelector('[data-rules-slide]');
        if (!track || !slide) return 0;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.gap || styles.columnGap || '0') || 0;

        // szerokość jednego slajdu w px (już po flex-basis)
        const slideW = slide.getBoundingClientRect().width;

        return slideW + gap;
    }

    function updateCarouselTransform(carouselEl) {
        const state = carouselState.get(carouselEl);
        const track = carouselEl.querySelector('[data-rules-track]');
        if (!state || !track) return;

        const step = getStepPx(carouselEl);
        const offset = -(state.index * step);

        track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }


    /* =========================
       SWIPE / DRAG
    ========================= */

    function initSwipe(carouselEl) {
        const viewport = carouselEl.querySelector('.rules-carousel__viewport');
        if (!viewport) return;

        const state = {
            isDown: false,
            startX: 0,
            startY: 0,
            dragged: false,
            blockClickUntil: 0
        };

        const DRAG_THRESHOLD = 8;
        const SWIPE_THRESHOLD = 50;

        viewport.addEventListener('pointerdown', (e) => {
            if (e.button !== 0) return;
            state.isDown = true;
            state.dragged = false;
            state.startX = e.clientX;
            state.startY = e.clientY;

            // (opcjonalnie) pointer capture czasem psuje click na desktopie
            // viewport.setPointerCapture?.(e.pointerId);
        });

        viewport.addEventListener('pointermove', (e) => {
            if (!state.isDown) return;

            const dx = e.clientX - state.startX;
            const dy = e.clientY - state.startY;

            if (Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
                state.dragged = true;
            }
        });

        viewport.addEventListener('pointerup', (e) => {
            if (!state.isDown) return;
            state.isDown = false;

            // viewport.releasePointerCapture?.(e.pointerId);

            // jeśli nie było dragu -> to był klik, GLightbox ma działać
            if (!state.dragged) return;

            // jeśli był drag -> blokujemy klik na 250ms (żeby nie odpalić lightboxa przy swipe)
            state.blockClickUntil = Date.now() + 250;

            const dx = e.clientX - state.startX;
            if (Math.abs(dx) < SWIPE_THRESHOLD) return;

            const carousel = carouselState.get(carouselEl);
            if (!carousel) return;

            if (dx < 0) goToSlide(carouselEl, carousel.index + 1);
            else goToSlide(carouselEl, carousel.index - 1);
        });

        viewport.addEventListener(
            'click',
            (e) => {
                // ✅ blokuj tylko “po dragu”
                if (Date.now() < state.blockClickUntil) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            true
        );

        viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }

})();

document.addEventListener('click', (e) => {
    const expandBtn = e.target.closest('.similarExpand');
    const closeBtn = e.target.closest('.similar-products .close');

    // =====================================================================
    // 👉 TOGGLE (otwieranie + zamykanie)
    // =====================================================================
    if (expandBtn) {
        const section = expandBtn.closest('.section-box__body');
        if (!section) return;

        const target = section.querySelector('.similar-products');
        if (!target) return;

        const isExpanded = expandBtn.getAttribute('aria-expanded') === 'true';

        // --- ZAMKNIJ ---
        if (isExpanded) {
            expandBtn.setAttribute('aria-expanded', 'false');
            expandBtn.textContent = 'Zobacz pasujące produkty';

            target.setAttribute('hidden', '');

            // Scroll do początku sekcji
            requestAnimationFrame(() => {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });

            return;
        }

        // --- OTWÓRZ ---
        expandBtn.setAttribute('aria-expanded', 'true');
        expandBtn.textContent = 'Ukryj pasujące produkty';

        target.removeAttribute('hidden');

        // Scroll do produktów z offsetem na sticky header
        requestAnimationFrame(() => {
            const y = target.getBoundingClientRect().top + window.pageYOffset - 96;
            window.scrollTo({ top: y, behavior: 'smooth' });
        });

        return;
    }

    // =====================================================================
    // 👉 ZAMYKANIE IKONĄ X
    // =====================================================================
    if (closeBtn) {
        const target = closeBtn.closest('.similar-products');
        const section = closeBtn.closest('.section-box__body');
        if (!target || !section) return;

        const expandBtn = section.querySelector('.similarExpand');

        target.setAttribute('hidden', '');

        if (expandBtn) {
            expandBtn.setAttribute('aria-expanded', 'false');
            expandBtn.textContent = 'Zobacz pasujące produkty';
        }

        // Scroll do początku bloku
        requestAnimationFrame(() => {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
});

// GA Events
import {kliknalPobierzDokumentacje} from "../../../assets/scripts/ga-events/kliknal-pobierz-dokumentacje.js"
import {kliknalPasujacyProduktWZastosowaniu} from "../../../assets/scripts/ga-events/kliknal-pasujacy-produkt-w-zastosowaniu.js"
import {kliknalPrzyciskZobaczPasujaceProduktyWZastosowaniu} from "../../../assets/scripts/ga-events/kliknal-przycisk-zobacz-pasujace-produkty-w-zastosowaniu.js"
import {kliknalPrzyciskZobaczTenProduktWZestawie} from "../../../assets/scripts/ga-events/kliknal-przycisk-zobacz-ten-produkt-w-zestawie.js"
import {kliknalWideo} from "../../../assets/scripts/ga-events/kliknal-wideo.js"
kliknalPobierzDokumentacje();
kliknalPasujacyProduktWZastosowaniu();
kliknalPrzyciskZobaczPasujaceProduktyWZastosowaniu();
kliknalPrzyciskZobaczTenProduktWZestawie();
kliknalWideo();


